import { useState } from 'react';

import _ from 'lodash';

const useMonthlyBillingQAM = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [QAModalHeadline, setQAModalHeadline] = useState('');
  const [QAModalTitle, setQAModalTitle] = useState('');
  const [QAModalDesc, setQAModalDesc] = useState(null);

  const toggleModal = (modalHeadline, modalTitle, modalDescription) => {
    setQAModalHeadline(modalHeadline);
    setQAModalTitle(modalTitle);
    setQAModalDesc(_.isFunction(modalDescription) && modalDescription());
    setIsModalVisible(!isModalVisible);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const isVisible = isModalVisible;
  const title = QAModalHeadline;

  return { isVisible, title, QAModalTitle, QAModalDesc, toggleModal, closeModal };
};

export default useMonthlyBillingQAM;
